<template>
  <v-container fluid grid-list-xl>
    <app-diagnostico
      :titulo="tituloPagina"
      :inicio="diagnostico.inicioComportamental"
      :fim="diagnostico.fimComportamental"
      :avaliado="avaliado"
    >
      <template v-slot:body>
        <!-- Não há comportamentos consolidados para avaliar -->
        <v-col v-if="semComportamentos">
          <app-alert
            type="warning"
            icon="warning"
            message="Não há comportamentos disponíveis para realizar a avaliação."
          />
        </v-col>

        <!-- Disponível apenas usuários do tipo REGULAR -->
        <v-col v-else-if="usuarioMapeamento.tipo !== 'REGULAR'">
          <info-dispensa mensagem="Usuário não realiza esta avaliação." />
        </v-col>

        <!-- A chefia está dispensada do diagnóstico -->
        <v-col v-else-if="tipo === 'CHEFIA' && isChefiaDispensada">
          <info-dispensa
            :mensagem="`Não é possível realizar a avaliação do gestor imediato. (${motivoDispensaChefia})`"
          />
        </v-col>

        <!-- Avaliação -->
        <v-col
          v-else
          centered
          cols="12"
          no-gutters
        >
          <avaliacao
            :titulo="tituloFormulario"
            :diagnostico="diagnostico"
            :tipo="tipo"
            :perspectiva="perspectiva"
            :inicio="diagnostico.inicioComportamental"
            :fim="diagnostico.fimComportamental"
            :tutorial="tutorial"
          />
        </v-col>
      </template>
    </app-diagnostico>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AppDiagnostico from '@/components/core/AppDiagnostico';
import AppAlert from '@/components/core/AppAlert';
import InfoDispensa from '@/components/diagnostico/InfoDispensa';
import Avaliacao from '@/components/diagnostico/Avaliacao';

export default {
  name: 'AutoAvaliacaoComportamento',

  components: {
    AppDiagnostico,
    AppAlert,
    InfoDispensa,
    Avaliacao,
  },

  data() {
    return {
      tipo: '',
      perspectiva: 'COMPORTAMENTAL',
    };
  },

  computed: {
    ...mapState({
      diagnostico: (state) => state.diagnostico.diagnostico,
      isDispensado: (state) => state.diagnostico.dispensado,
      isChefiaDispensada: (state) => state.diagnostico.chefiaDispensada,
      motivoDispensaChefia: (state) => state.diagnostico.motivoDispensaChefia,
      usuarioMapeamento: (state) => state.mapeamento.usuarioMapeamento,
    }),
    avaliado() {
      const avaliacaoProp = this.tipo === 'AUTOAVALIACAO' ? 'autoavaliacaoComportamental' : 'chefiaComportamental';
      const avaliacao = { ...this.$store.state.diagnostico[avaliacaoProp][0] };
      return avaliacao && avaliacao.avaliado ? avaliacao.avaliado.nome : '';
    },
    tituloPagina() {
      return this.tipo === 'AUTOAVALIACAO'
        ? 'Autoavaliação (Competências Comportamentais)'
        : 'Avaliação do Gestor Imediato (Competências Comportamentais)';
    },
    tituloFormulario() {
      return this.tipo === 'AUTOAVALIACAO' ? 'AUTOAVALIAÇÃO' : 'AVALIAÇÃO DO GESTOR IMEDIATO';
    },
    tutorial() {
      let nome = '';
      if (this.tipo === 'AUTOAVALIACAO') {
        nome = 'Autoavaliacao';
      }
      if (this.tipo === 'CHEFIA') {
        nome = 'AvaliacaoGestor';
      }
      return { nome };
    },
    semComportamentos() {
      return this.$store.state.diagnostico.comportamentos.length === 0;
    },
  },

  created() {
    if (this.$route.name === 'AutoAvaliacaoComportamento') {
      this.tipo = 'AUTOAVALIACAO';
    } else if (this.$route.name === 'AvaliacaoChefiaComportamento') {
      this.tipo = 'CHEFIA';
    }
  },
};
</script>
